var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event-action-container"},[_c('v-btn',{staticClass:"mb-2",attrs:{"color":"secondary"},on:{"click":_vm.handleButtonClick}},[_vm._v(" Add Video Files ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }